import { ProductIds } from 'core'
import getBenefitClasses from 'core/application/csiDashboard/csiSearch/getBenefitClasses'
import getProductClassDetails from 'core/application/csiDashboard/csiSearch/getProductClassDetails'
import getProductEligibleEmployees from 'core/application/csiDashboard/csiSearch/getProductEligibleEmployees'

import ClassesSummary from 'common/components/benefit/ClassesSummary'

import { Col, Row, Skeleton } from 'common/components'
import { useQueryRequestV2 } from 'common/hooks'

import BenefitHeader from './benefitHeader'

interface BenefitClassesProps {
  translate: (key: string) => string
  planPeriodId: string
  productId: ProductIds
}

const BenefitClasses = ({ translate, planPeriodId, productId }: BenefitClassesProps) => {
  const { data: benefitDetails, isLoading: loadingBenefitDetails } = useQueryRequestV2({
    initialState: null,
    queryFn: () => getBenefitClasses(planPeriodId),
  })

  return (
    <>
      <Row>
        <Col md={24}>
          <Skeleton loading={loadingBenefitDetails}>
            {benefitDetails && <BenefitHeader benefitDetails={benefitDetails} translate={translate} />}
          </Skeleton>
        </Col>
      </Row>
      <Row className="mt-24">
        <Col md={24}>
          <Skeleton loading={loadingBenefitDetails}>
            {benefitDetails && (
              <ClassesSummary
                classes={benefitDetails.classes}
                sameClassForAll={benefitDetails.sameClassForAll}
                apiEndpoint={getProductClassDetails}
                eligibleEmployeesEndpoint={getProductEligibleEmployees}
                productId={productId}
              />
            )}
          </Skeleton>
        </Col>
      </Row>
    </>
  )
}

export default BenefitClasses
